// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 413) return "js/admin/autocomplete.js";
	if (chunkId === 831) return "js/admin/clinic-search.js";
	if (chunkId === 773) return "js/admin/clinic-profile.js";
	if (chunkId === 862) return "js/admin/booking.js";
	if (chunkId === 291) return "js/admin/book-treatment.js";
	if (chunkId === 448) return "js/admin/add-credit-card.js";
	if (chunkId === 437) return "js/admin/create-payment.js";
	// return url for filenames based on template
	return undefined;
};